export default "__VITE_ASSET__aadd0981__"